import * as types from './types';
import * as sagaTypes from './../../types';



export const actionChangeInputLoginPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_LOGIN', name, value
});








/***************AUTH****************/
export const actionChangeTokenUser = (token) => ({
    type: types.CHANGE_TOKEN,
    payload:{token}
});

export const actionChangeTokenUserByAdmin = (token, is_admin) => ({
    type: types.CHANGE_STATUS_LOGIN_BY_ADMIN,
    token, is_admin
});

export const actionChangeInputFormSendPhone = (phone) => ({
    type: types.CHANGE_PHONE_FORM_SEND_PHONE,
    phone
});
export const actionChangeIntroducedInputFormSendPhone = (introducedCode) => ({
    type: types.CHANGE_INTRODUCED_CODE_FORM_SEND_PHONE,
    introducedCode
});
export const actionChangeLoaderBtnFormSendPhone = (loaderBtn) => ({
    type: types.CHANGE_LOADER_BTN_FORM_SEND_PHONE,payload:{loaderBtn}
});

export const actionChangeInputFormSendCodeValidation = (code) => ({
    type: types.CHANGE_CODE_FORM_OTP_VALIDATION,
    code
});
export const actionChangeLoaderBtnFormSendCodeValidation = (loaderBtn) => ({
    type: types.CHANGE_LOADER_BTN_FORM_OTP_VALIDATION,
    loaderBtn
});
export const actionChangeDataFormSendCodeValidation = (name, value) => ({
    type: types.CHANGE_DATA_FORM_OTP_VALIDATION,
    name, value
});
export const actionChangeDataFormLoginStaff = (name,value) => ({
    type: types.CHANGE_DATA_FORM_LOGIN_STAFF,payload:{name,value}
});

/*SAGAS*/
export const fetchLoginUserSaga = (payload) => ({
    type: sagaTypes.LOGIN_USER_SAGA, payload
});
export const fetchLoginUserStaffSaga = (payload) => ({
    type: sagaTypes.LOGIN_USER_STAFF_SAGA, payload
});

export const setTimerLoginUserSaga = (timer) => ({
    type: sagaTypes.SET_TIMER_LOGIN_SAGA, payload: {timer}
});
export const fetchActiveUserSaga = (code) => ({
    type: sagaTypes.ACTIVE_USER_SAGA, payload:{code}
});
export const fetchResendCodeSaga = (mobile) => ({
    type: sagaTypes.RESEND_CODE_SAGA, payload:{mobile}
});


/***************USER****************/
export const actionChangeDataUser = (name, value) => ({
    type: types.CHANGE_DATA_USER, name, value
});
export const actionChangeProfileUser = (profile) => ({
    type: types.CHANGE_PROFILE_USER, payload:{profile}
});
export const actionChangeItemProfileUser = (name, value) => ({
    type: types.CHANGE_ITEM_PROFILE_USER, name, value,
});
export const actionChangeInputsEditProfileUser = (name, value) => ({
    type: types.EDIT_PROFILE_USER, name, value,
});
export const actionResetEditProfileUser = () => ({
    type: types.RESET_EDIT_PROFILE_USER
});
export const actionResetProfileUser = () => ({
    type: types.RESET_PROFILE_USER
});

/*Addresses*/
export const actionSetListAddressUser = (listAddresses) => ({
    type: types.SET_LIST_ADDRESSES_USER, listAddresses
});
export const actionSetListAreas = (listAreas) => ({
    type: types.SET_LIST_AREAS, listAreas
});
export const actionSelectedAddressUser = (selectedAddress) => ({
    type: types.SELECTED_ADDRESS_FOR_DEFAULT, selectedAddress
});
export const actionChangeDataAddAddress = (name, value) => ({
    type: types.CHANGE_DATA_ADD_ADDRESS_PAGE_ADDRESSES, name, value
});
export const actionChangeDataAddress = (name, value) => ({
    type: types.CHANGE_DATA_ADDRESS_PAGE_ADDRESSES, name, value
});

/*Charge Wallet*/
export const actionChangeInputPriceChargeWalletUser = (price) => ({
    type: types.CHANGE_INPUT_PRICE_CHARGE_WALLET, price
});

/*wallet Transactions*/
export const actionChangeDataWallet = (transactions, total, total_rows, offset) => ({
    type: types.CHANGE_DATA_WALLET, transactions, total, total_rows, offset
});
export const actionChangeLoaderMyWallet = (loader) => ({
    type: types.CHANGE_LOADER_MODAL_WALLET, loader
});

export const actionChangeDataFactors = (factors, total_rows, offset) => ({
    type: types.CHANGE_DATA_FACTORS, factors, total_rows, offset
});
export const actionChangeLoaderMyFactors = (loader) => ({
    type: types.CHANGE_LOADER_MY_FACTORS, loader
});

/*MyOrders*/
export const actionChangeLoaderMyOrders = (loader) => ({
    type: types.CHANGE_LOADER_MODAL_MY_ORDERS, loader
});
export const actionDataMyOrders = (contents, total_rows, offset) => ({
    type: types.CHANGE_DATA_MY_ORDERS, contents, total_rows, offset
});
export const actionChangeTextSurveyRealTime = (id, text) => ({
    type: types.CHANGE_TEXT_SURVEY_REAL_TIME, id, text
});
